import { parseISO } from 'date-fns';
import { GameModel } from '../types';

const toGameModel = (game: GameModel): GameModel => ({
  ...game,
  startTimestamp: game.startTimestamp ? parseISO(game.startTimestamp.toString()) : null,
  endTimestamp: game.endTimestamp
    ? parseISO(game.endTimestamp.toString())
    : null,
});

export default toGameModel;
